import { Heart } from "lucide-react";

function HeroGeometry() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0">
      {/* Large pale aqua partial circle entering from the top right */}
      <div className="absolute -right-28 -top-40 h-[400px] w-[400px] rounded-full bg-brand-aqua/70 md:-top-56 md:h-[520px] md:w-[520px] lg:-right-28" />
      {/* Soft peach translucent circle behind the right hero area */}
      <div className="absolute right-[6%] top-[24%] h-[300px] w-[300px] rounded-full bg-brand-peach/35 md:right-[14%] md:h-[420px] md:w-[420px] lg:right-[16%] lg:top-[18%]" />
      {/* Peach circle toward the far right */}
      <div className="absolute -right-10 top-[44%] h-[140px] w-[140px] rounded-full bg-brand-peach/70 md:right-[2%] md:h-[160px] md:w-[160px]" />
      {/* Thin coral arc */}
      <div className="absolute right-[30%] top-[6%] hidden h-[96px] w-[96px] rounded-full border-2 border-brand-coral/40 border-b-transparent border-l-transparent md:right-[34%] md:top-[10%] md:block md:h-[120px] md:w-[120px]" />
      {/* Subtle pale coral curved line */}
      <div className="absolute right-[22%] top-[20%] hidden h-[220px] w-[220px] rounded-full border-2 border-brand-coral/15 border-r-transparent border-t-transparent md:right-[26%] md:block md:h-[280px] md:w-[280px]" />
      {/* Partial pastel shape entering from the left edge */}
      <div className="absolute -left-20 bottom-[-60px] h-[200px] w-[200px] rounded-full bg-brand-peach/55 md:-left-16 md:h-[240px] md:w-[240px]" />
      {/* Small aqua accent entering from the left */}
      <div className="absolute -left-10 top-[30%] hidden h-[90px] w-[90px] rounded-full bg-brand-aqua/50 lg:block" />
    </div>
  );
}

function SpeechBubble() {
  return (
    <div
      className="hero-bubble-enter absolute -top-[80px] left-[48%] md:-top-[86px] md:left-[52%]"
      data-testid="sophie-speech-bubble"
    >
      <div className="relative w-max rounded-[22px] rounded-bl-md border border-brand-teal/10 bg-white px-5 py-3 text-center shadow-[0_8px_22px_rgba(7,88,102,0.09)]">
        <p className="text-[18px] font-extrabold leading-[1.15] text-brand-teal md:text-[19px]">
          Hi!
          <br />
          I&rsquo;m Sophie
        </p>
        <Heart
          aria-hidden="true"
          className="mx-auto mt-1.5 h-4 w-4 fill-brand-coral text-brand-coral"
        />
        <span
          aria-hidden="true"
          className="absolute -bottom-[9px] left-[20px] h-4 w-4 rotate-45 border-b border-l border-brand-teal/10 bg-white"
        />
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <section
      id="home"
      aria-labelledby="hero-heading"
      className="relative overflow-hidden"
      data-testid="hero-section"
    >
      <HeroGeometry />
      <div className="symp-container relative">
        <div className="grid gap-8 pb-8 pt-2 md:gap-10 md:pb-10 lg:grid-cols-[minmax(0,1.3fr)_minmax(280px,0.7fr)] lg:items-end lg:gap-4 lg:pb-0 lg:pt-0">
          <div className="max-w-[820px] lg:self-center lg:pb-14 lg:pt-8">
            <h1
              id="hero-heading"
              data-testid="hero-heading"
              className="hero-title text-brand-teal"
            >
              The story does not stop
              <br className="hidden sm:block" />{" "}
              <span className="text-brand-coral">when the visit ends.</span>
            </h1>
            <p
              data-testid="hero-supporting-copy"
              className="mt-5 max-w-[700px] text-[18px] font-medium leading-[1.55] text-brand-ink md:mt-6 md:text-[20px] lg:text-[21px] lg:leading-[1.5]"
            >
              SympTrack turns the patient experience between visits into clear,
              evidence linked context a care team can review.
            </p>
          </div>
          <div
            className="relative flex justify-center lg:items-end"
            data-testid="hero-sophie-wrap"
          >
            <div className="relative mt-[92px] md:mt-[100px]">
              <SpeechBubble />
              <img
                src="/images/sophie.png"
                alt="Sophie, the SympTrack heart character."
                width="1516"
                height="1328"
                className="hero-sophie-enter block h-auto w-[230px] sm:w-[250px] md:w-[270px] lg:w-[280px] xl:w-[300px]"
                data-testid="hero-sophie"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
